import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/TeamPage.css';

const TeamPage = () => {
  const founders = [
    {
      id: 1,
      name: 'Kamati Hasheela',
      position: 'Co-Founder & CEO',
      email: 'khasheela@pulsarelectronic.com',
      image: '/images/Kamati.png',
      description: 'Kamati holds a Bachelor\'s degree in Electronics and Telecommunication Engineering. He has a background in electronics & software systems design with experience in the telecommunication and utility industries. He leads the technical aspects of product development and oversees management & operations along with Adrian.'
    },
    {
      id: 2,
      name: 'Adrian Larreal',
      position: 'Co-Founder & CFO',
      email: 'alarreal@pulsarelectronic.com',
      image: '/images/Adrian.jpg',
      description: 'Adrian holds a Bachelor\'s degree in Economics, as well as a Master\'s degree in Applied Economics. His experience spans across utilities, oil & gas, and investment banking. He oversees financials, management, and operational strategy along with Kamati.'
    },
    {
      id: 3,
      name: 'Delano January',
      position: 'Co-Founder & COO',
      image: '/images/Delano.jpg',
      description: 'Having spent more than 18 years in the utility industry, Delano has had the opportunity to work with different aspects of industry over vast array of platforms and technologies, giving him a unique perspective on technical implementations and business solutions. He is passionate about innovation, breaking down barriers, building relationships and the edge gained through the creative use of technology. He holds a bachelor\'s degree in information technology from Polytechnic of Namibia.'
    },
  ];

  const teamMembers = [
    {
      id: 3,
      name: 'Pareekshit Sachan',
      position: 'Software Engineer',
      image: '/images/Pareekshit.jpeg',
      description: 'Pareekshit is a Software Engineer at Pulsar Electronic Solutions, working across full-stack development, embedded integrations, and automation tools. He helps bridge software and hardware to deliver stable, efficient systems. He holds a bachelor’s degree in Electronics and Telecommunication Engineering from NUST and is pursuing a Master of Science in Electrical Engineering at the University of Cape Town.'
    },
    {
      id: 3,
      name: 'Jose Almirall',
      position: 'Embedded Engineer',
      image: '',
      description: "Jose is an Embedded Engineer at Pulsar Electronic Solutions, working on device firmware, hardware diagnostics, and system-level integrations. He supports the development and maintenance of embedded platforms across the company’s product line, ensuring reliable performance and smooth operation. He is currently pursuing a bachelor’s degree in Electronics and Telecommunication Engineering at the Namibia University of Science and Technology."
    },
  ];

  const advisors = [
    {
      id: 5,
      name: 'Dantagos Jimmy-Melani',
      position: 'Managing Advisor',
      image: '/images/Dantagos.jpg',
      description: 'Dantagos has over seventeen years of experience in the international business, financial services and media sectors. She has been developing public interest focused training, mentoring, coaching and corporate advisory programs for over eight years, as the founder of Ndapunikwa Investments. Dantagos graduated from Maastricht School of Management with a MBA and holds a Bachelor of Science from La Roche University in Pittsburgh, Pennsylvania. She is a registered person with the South African Institute of Financial Markets, and certified as a securities trader by the Johannesburg Stock Exchange.'
    },
  ];

  return (
    <div className="team-page-full">
      <div className="team-page-full__content">
        <div className="team__header">
          <h2 className="team__title">The Pulsar Electronic Solutions Team</h2>
          <p className="team__description">
            Our team embraces diversity, open collaboration, and the use of technology to develop innovative initiatives that transform our communities
          </p>
        </div>
        
        <div className="team__section">
          <h3 className="team__section-title">Co-Founders</h3>
          <div className="team__grid team__grid--founders">
            {founders.map((member) => (
              <div key={member.id} className="team__card team__card--founder">
                <div className="team__image-wrapper">
                  <img src={member.image} alt={member.name} className="team__image" />
                </div>
                <h3 className="team__name">{member.name}</h3>
                <p className="team__position">{member.position}</p>
                <a href={`mailto:${member.email}`} className="team__email">{member.email}</a>
                <p className="team__bio">{member.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="team__section">
          <h3 className="team__section-title">Core Team</h3>
          <div className="team__grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team__card">
                <div className="team__image-wrapper">
                  {member.image ? (
                    <img src={member.image} alt={member.name} className="team__image" />
                  ) : (
                    <div className="team__image-placeholder">
                      {member.name.charAt(0)}
                    </div>
                  )}
                </div>
                <h3 className="team__name">{member.name}</h3>
                <p className="team__position">{member.position}</p>
                <p className="team__bio">{member.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="team__section">
          <h3 className="team__section-title">Advisory Board</h3>
          <div className="team__grid">
            {advisors.map((member) => (
              <div key={member.id} className="team__card">
                <div className="team__image-wrapper">
                  <img src={member.image} alt={member.name} className="team__image" />
                </div>
                <h3 className="team__name">{member.name}</h3>
                <p className="team__position">{member.position}</p>
                <p className="team__bio">{member.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="team__join-section">
          <div className="team__join-content">
            <h2 className="team__join-title">Join Our Team</h2>
            <p className="team__join-text">
              We're always looking for talented, passionate individuals who want to make a difference. 
              If you're excited about using technology to transform communities and improve lives, 
              we'd love to hear from you.
            </p>
            <div className="team__join-buttons">
              <Link to="/careers" className="team__join-button team__join-button--primary">
                View Open Positions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamPage;
